// extracted by mini-css-extract-plugin
module.exports = {"projects":"style_projects__2yjRB","noProjects":"style_noProjects__ACVNA"};